import { render, staticRenderFns } from "./EvaluacionMedica.vue?vue&type=template&id=4d2267e2"
import script from "./EvaluacionMedica.vue?vue&type=script&lang=js"
export * from "./EvaluacionMedica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports